import { reactive, ref } from "@vue/composition-api";
import _axios from "@/axios";
import { handleFormErrors } from "@/composables/form-error";
import { showSnackBar } from "@/composables/snackbar";

export function usePortalProfile() {
  const portalProfiles = ref([]);
  const portalProfileForm = ref(null);

  const portalProfileData = reactive({
    portalProfileDialog: false,
    portalProfileFormRef: null,
    nameRules: [(v) => !!v || "La template doit avoir un nom"],
    descriptionRules: [(v) => !!v || "La template doit avoir une description"],
    vatRules: [(v) => !!v || "La TVA est requise"],
    portalPresentationModelDialog: false,
    portalPresentationThemeDialog: false,
    portalPresentationOtherDialog: false,
    portalConfigurationLanguageDialog: false,
    portalConfigurationPresentationDialog: false,
    portalConfigurationOtherDialog: false,
    portalConfigurationRules: {
      languagesRules: [
        (v) => !!v || "Il faut selectionner au moins une langue",
      ],
      default_languageRules: [(v) => !!v || "Il faut une langue par défault"],
    },
  });

  const closeAllDialogs = () => {
    portalProfileData.portalPresentationModelDialog = false;
    portalProfileData.portalPresentationThemeDialog = false;
    portalProfileData.portalPresentationOtherDialog = false;
    portalProfileData.portalConfigurationLanguageDialog = false;
    portalProfileData.portalConfigurationPresentationDialog = false;
    portalProfileData.portalConfigurationOtherDialog = false;
  };

  function createPortalProfile(partnerId) {
    portalProfileForm.value.partner = partnerId;
    delete portalProfileForm.value.portalOptions.presentationModel;
    delete portalProfileForm.value.portalConfigurationModel;

    if (portalProfileData.portalProfileFormRef != null) {
      const isValid = portalProfileData.portalProfileFormRef.validate();
      if (!isValid) {
        return;
      }
    }
    return _axios
      .post("/portal-profile/create", portalProfileForm.value)
      .then(() => {
        listPortalProfileV5(partnerId);
        portalProfileData.portalProfileDialog = false;
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function updatePortalProfile(portalProfileId, partnerId) {
    if (portalProfileData.portalProfileFormRef != null) {
      const isValid = portalProfileData.portalProfileFormRef.validate();
      if (!isValid) {
        return;
      }
    }

    delete portalProfileForm.value.portalOptions.presentationModel;
    delete portalProfileForm.value.portalConfigurationModel;
    delete portalProfileForm.value.partner;
    delete portalProfileForm.value.portalConfiguration;

    return _axios
      .put("/portal-profile/" + portalProfileId, portalProfileForm.value)
      .then(() => {
        listPortalProfileV5(partnerId);
        portalProfileData.portalProfileDialog = false;
        showSnackBar();
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          portalProfileData,
          portalProfileData.portalProfileFormRef
        );
      });
  }

  function listPortalProfileV5(partnerId = null) {
    if (partnerId == null) {
      partnerId = 1; // PASSMAN
    }
    return _axios
      .get("/list-portal-profile-v5/" + partnerId)
      .then((response) => {
        portalProfiles.value = response.data.data;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          portalProfileData,
          portalProfileData.portalProfileFormRef
        );
      });
  }

  function showPortalProfile(id) {
    return _axios
      .get("/portal-profile/" + id)
      .then((response) => {
        portalProfileForm.value = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function updatePortalConfiguration(
    id,
    portalConfigurationFom,
    isInherit = false,
    isBuiltIn = false,
    portalProfile = null,
    portalConfigurationFormRef = null
  ) {
    console.log(isInherit, isBuiltIn, portalProfile);

    if (portalConfigurationFormRef != null) {
      const isValid = portalConfigurationFormRef.validate();
      if (!isValid) {
        return;
      }
    }

    const formData = {
      portal_configuration: portalConfigurationFom,
    };

    _axios
      .put(`/portal-profile-update-portal-configuration/${id}`, formData)
      .then((response) => {
        portalProfileForm.value = response.data.data;
        closeAllDialogs();
        showSnackBar();
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          portalProfileData.portalConfigurationRules,
          portalConfigurationFormRef
        );
        alert(error.response.data.detail);
      });
  }

  function deletePortalProfile(portalProfile, partnerId) {
    return _axios
      .delete("/portal-profile/" + portalProfile.id)
      .then(() => {
        listPortalProfileV5(partnerId);

        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function updatePortalConfigurationModel(id, formData) {
    return _axios
      .put(`/portal-profile-update-portal-model/${id}`, formData)
      .then((response) => {
        portalProfileForm.value = response.data.data;
        closeAllDialogs();
        showSnackBar();
      })
      .catch((error) => {
        alert(error.response.data.detail);
      });
  }

  function updatePortalConfigurationSparse(id, formData) {
    return _axios
      .put(`/portal-profile-update-portal-configuration-sparse/${id}`, formData)
      .then((response) => {
        portalProfileForm.value = response.data.data;
        closeAllDialogs();
        showSnackBar();
      })
      .catch((error) => {
        alert(error.response.data.detail);
      });
  }
  return {
    portalProfileData,
    portalProfiles,
    portalProfileForm,
    listPortalProfileV5,
    showPortalProfile,
    createPortalProfile,
    updatePortalProfile,
    updatePortalConfiguration,
    deletePortalProfile,
    updatePortalConfigurationModel,
    updatePortalConfigurationSparse,
  };
}
